import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { CooMeetAlternativeBanner } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function CooMeetAlternative() {
  return (
    <>
      <SEO
        title="Best CooMeet Alternative - Talkvee (100% Free & No Coins)"
        description="Looking for a free CooMeet alternative? Talkvee is a 100% free video chat platform. No coins, no subscriptions, just authentic conversations and fun games."
        pathname="/coomeet-alternative"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "CooMeet Alternative", "item": "https://talkvee.com/coomeet-alternative" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <CooMeetAlternativeBanner />
        
        <section className="landing-hero">
          <h1 className="landing-title">The 100% Free CooMeet Alternative</h1>
          <p className="landing-subtitle">
            Tired of paying for video chats or running out of coins? Talkvee connects you with real people globally for free. Enjoy authentic conversations with interest matching and built-in games.
          </p>
          <Link to="/" className="tv-cta">🚀 Start Chatting on Talkvee</Link>
        </section>

        <section className="comparison-section" style={{maxWidth: '800px', margin: '40px auto', padding: '0 15px'}}>
          <h3 style={{textAlign: 'center', marginBottom: '20px', color: 'var(--tv-text)'}}>Talkvee vs. CooMeet</h3>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', textAlign: 'left'}}>
            <div style={{background: '#fee2e2', padding: '20px', borderRadius: '12px', border: '1px solid #fecaca'}}>
              <h4 style={{margin: '0 0 10px', color: '#b91c1c', fontSize: '1.1rem'}}>❌ CooMeet</h4>
              <ul style={{paddingLeft: '20px', margin: 0, color: '#7f1d1d', lineHeight: '1.6'}}>
                <li>Expensive Premium Memberships</li>
                <li>Pay-Per-Minute System</li>
                <li>Highly Monetized</li>
              </ul>
            </div>
            <div style={{background: '#dcfce7', padding: '20px', borderRadius: '12px', border: '1px solid #bbf7d0'}}>
              <h4 style={{margin: '0 0 10px', color: '#15803d', fontSize: '1.1rem'}}>✅ Talkvee</h4>
              <ul style={{paddingLeft: '20px', margin: 0, color: '#14532d', lineHeight: '1.6'}}>
                <li>100% Free Forever</li>
                <li>No Coins or Hidden Fees</li>
                <li>Interest-Based Matching</li>
              </ul>
            </div>
          </div>
        </section>

        <FAQSection
          items={[
            {
              q: "Is Talkvee really a free CooMeet alternative?",
              a: "Yes! While CooMeet requires premium subscriptions or coins to use many features, Talkvee is completely free. We do not use a pay-per-minute model."
            },
            {
              q: "Are the people on Talkvee real?",
              a: "Yes. We focus on authentic connections and heavily moderate the platform to remove bots, ensuring you talk to real people."
            },
            {
              q: "Do I need to sign up to use Talkvee?",
              a: "No! You can jump straight into a video chat using our quick guest login. You only sign up if you want to save your username and leaderboard points."
            }
          ]}
        />
      </div>
    </>
  );
}